import * as playerConstant from '../utils/playerConstants';
import PlayerStates from '../utils/PlayerStates';
export const SET_PLAYERS_STATE = 'SET_PLAYERS_STATE';

// DOC https://dlatvarg.atlassian.net/wiki/spaces/DAMCO/pages/250741191/Diagrama+de+estados+de+los+reproductores

/*
const initialState = {
    
  singlefullplayerstate: {
    currentstate: NOT_PLAYING,
    previosstate: NOT_PLAYING
  },

  singlepipplayerstate: {
    currentstate: NOT_PLAYING,
    previosstate: NOT_PLAYING
  },

  currentplayersstate: NOT_PLAYING,
  previousplayersstate: NOT_PLAYING
};
*/

/*
export const updatePlayerState = (dispatch, getState, newPlayerInfo) => {
  
  //newPlayerInfo = {
  //  isFull: true/false (false for pip),
  //  internalState: NOT_PLAYING/PLAYING_LIVE_DVB/PLAYING_LIVE_IP etc etc etc
  //}
  const currentplayerstate = getState().playerstates;
  let responseResolveState = PlayerStates.resolveNewStatus(currentplayerstate, newPlayerInfo);

  let newPlayerState = responseResolveState;
  delete newPlayerState.forcefullstop;
  delete newPlayerState.forcepipstop;
  
  return dispatch(setPlayerState(newPlayerState));
};
*/
// *** This dispatch should be internal, called only from updatePlayerState above ***
export const setPlayerState = (playerStates) => (
  {
    type: SET_PLAYERS_STATE, 
    playerStates: playerStates
  }
);


// WEBPACK FOOTER //
// ./src/actions/playerstates.js